module.exports = __webpack_public_path__ + "img/大雨.88af4bb1.png";